import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalController } from '@ionic/angular/standalone';
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent } from '@ionic/angular/standalone';
import { DisplayService } from '@qid/core';
import { SexyModule } from "@qid/sexy";
import { PageLoaderComponent } from "@qid/super";
import { SID } from '../../../sid';
import { IdService } from '../../services/id.service';

@Component({
  selector: 'app-id-verification',
  templateUrl: './id-verification.page.html',
  styleUrls: ['./id-verification.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    PageLoaderComponent,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent
  ]
})
export class IdVerificationPage implements OnInit {

  public sid: SID = null;

  constructor(private idService: IdService,
              private modalController: ModalController,
              private displayService: DisplayService
  ) {
  }

  ngOnInit() {
  }

  ionViewDidEnter() {

  }


  back() {
    this.modalController.dismiss()
  }
}
